class StringHelper {
  static trimObjectStrings(dataObject) {
    for (const key in dataObject) {
      if (typeof dataObject[key] === 'string') {
        dataObject[key] = dataObject[key].trim();
      } else if (typeof dataObject[key] === 'object') {
        dataObject[key] = this.trimObjectStrings(dataObject[key]);
      }
    }
    return dataObject;
  }
}

export { StringHelper }